module.exports = __webpack_public_path__ + "assets/img/C1.af8683f9.jpg";